import charts from '../charts.js';
import seasonalityChart from '../charts/seasonality.js';
import annualGainsChart from '../charts/annual-gains.js';
import ChartPage from '../includes/chart-page.js';
import moment from 'moment';

let chartPage;
let numFutureWeeks = 52;
let defaultSeasonalityStart;
let defaultSeasonalityEnd;
let annualDataTotal;

function drawColumnChart(res) {
	if ($("#chart-annual-return-div").length === 0) {
		return;
	}

	annualGainsChart({
		id: 'chart-annual-return-div',
		data: res.annualData,
		config: {},
	});
}

function handleSeasonalitySelection() {
	const start = chartPage.section.find("[name='seasonality_selection_start']").val();
	const end = chartPage.section.find("[name='seasonality_selection_end']").val();

	setSeasonalitySelection(start, end);
	getBestPeriod();
}

function setSeasonalitySelection(start, end) {
	const hidden = [];
	const visible = [];
	let enabled = false;

	if (start === defaultSeasonalityStart && end === defaultSeasonalityEnd) {
		visible.push('future');
		hidden.push('seasonality_selection');
		hidden.push('seasonality_selection_value');
	} else {
		hidden.push('future');
		visible.push('seasonality_selection');
		visible.push('seasonality_selection_value');
		enabled = true;
	}

	for (const name of visible) {
		chartPage.chart.toggleSeries(name, true);
	}

	for (const name of hidden) {
		chartPage.chart.toggleSeries(name, false);
	}

	const startDate = moment(start);
	const endDate = moment(end);

	let selectionStart;
	let selectionEnd;

	let numYears = 0;
	let numWinning = 0;

	chartPage.chartData = chartPage.chartData.map(row => {
		row.seasonality_selection = null;
		row.seasonality_selection_value = null;
		row.seasonality_selection_track_record = null;

		if (!row.week) {
			return row;
		}

		const rowDate = moment(row.date);

		const rowInRange = startDate.isSameOrBefore(rowDate) &&
			endDate.isSameOrAfter(rowDate);

		if (rowInRange) {
			if (!selectionStart) {
				selectionStart = row;
			}

			selectionEnd = row;

			row.seasonality_selection_value = row.projected_close;

			numYears += row.num_years;
			numWinning += row.num_winning;
		}

		return row;
	});

	const trackRecord = Math.round(10000 * numWinning / numYears) / 100;

	const seasonalitySelection = (selectionStart && selectionEnd) ?
		Math.round(((selectionEnd.chart_close / selectionStart.chart_close) - 1) * 10000) / 100 :
		null;

	chartPage.chartData = chartPage.chartData.map(row => {
		if (row.seasonality_selection_value) {
			row.seasonality_selection = seasonalitySelection;
			row.seasonality_selection_track_record = trackRecord;
		}

		return row;
	});

	chartPage.refreshData();
}

function getCustomSeasonalityData() {
	const data = $('#seasonality-filters').serializeJSON();

	$('.seasonality-setting-seasonality_years').text(+data.seasonality_years > +annualDataTotal ? `${annualDataTotal}+` : data.seasonality_years);

	ajax('getCustomSeasonalityData', data, function(res) {
		setCustomSeasonalityData(res.chartData);

		if (res.period) {
			setBestPeriod(res.period);
		}

		handleSeasonalitySelection();

		chartPage.refreshData();
	});
}

function setCustomSeasonalityData(seasonality) {
	chartPage.chartData = chartPage.chartData.filter(row => row.hasOwnProperty('weeksAgo'));

	chartPage.chartData = [
		... chartPage.chartData,
		... seasonality,
	];
}

function getBestPeriod(data = false) {
	if (!data) {
		data = $('#seasonality-filters').serializeJSON();
	}

	ajax('getBestPeriod', data, function(res) {
		setBestPeriod(res.period);
		chartPage.refreshData();
	});
}

function setBestPeriod(bestPeriod) {
	chartPage.chartData = chartPage.chartData.map(row => {
		if (!bestPeriod) {
			row.best_period = null;
			row.best_period_value = null;
		} else if (row.week >= bestPeriod.start_week && row.week <= bestPeriod.end_week) {
			row.best_period = bestPeriod;
			row.best_period_value = row.projected_close;
		} else {
			row.best_period = null;
			row.best_period_value = null;
		}

		return row;
	});
}

function getNumYearsWithChange() {
	const row = chartPage.chartData.find(row => row.week === numFutureWeeks);
	const gainLoss = row.gain_loss;
	const rising = gainLoss > 0;

	$(".stock-timeline-stats-weeks").text(numFutureWeeks);
	$(".stock-timeline-stats-percent-change").text(Math.abs(row.gain_loss));
	$(".stock-timeline-stats-direction").text(rising ? 'risen' : 'fallen');
	$(".stock-timeline-stats-num-years-change").text(rising ? row.num_winning : row.num_losing);
	$(".stock-timeline-stats-total-years").text(row.num_years);
	$(".stock-timeline-stats-historical-probability").text(rising ? row.probability : row.probability_decrease);
}

export default async function seasonalitySection(res, section, data) {
	chartPage = new ChartPage();

	numFutureWeeks = res.numFutureWeeks || 52;
	annualDataTotal = res.annualDataTotal;

	defaultSeasonalityStart = res.lastData?.date;
	defaultSeasonalityEnd = res.chartData?.[ res.chartData.length - 1 ].date;

	await chartPage.init({
		res,
		section,
		data,
		sectionName: 'seasonality',
		hasRemainingData: false,
		chartSettings: seasonalityChart,
		timePeriod: 'weeks',
		sliderDefault: 52,
		callbacks: {
			buildEmbed: () => {
				const formData = $('#seasonality-filters').serializeJSON();

				const data = {};

				if (chartPage.section.find('.filters').hasClass('active')) {
					data.bestPeriod = formData.period_length;
					data.seasonalityYears = formData.seasonality_years;
					data.seasonalitySelectionStart = formData.seasonality_selection_start;
					data.seasonalitySelectionEnd = formData.seasonality_selection_end;
				}

				return data;
			},

			getEndDate: () => {
				return moment(res.lastData.date).add(numFutureWeeks * 7, 'days');
			},

			drawChart: () => {
				if (window.config.url.data[0] !== 'chart') {
					numFutureWeeks = chartPage.form.get('future_timeline');
				}

				chartPage.zoomChart();
			},

			chartScrollbar: event => {
				const futureEndDate = moment.min(moment(event.endDate), moment(defaultSeasonalityEnd));
				numFutureWeeks = Math.max(0, Math.ceil(futureEndDate.diff(chartPage.lastData.date, 'weeks', true)));

				chartPage.form.set('future_timeline', numFutureWeeks, true);
			},
		},
	});

	if (chartPage.form) {
		chartPage.form.setCallback('future_timeline', 'set', () => {
			chartPage.drawChart();
			getNumYearsWithChange();
		});

		chartPage.form.setCallback('presidential', 'set', (val) => {
			const slider = $('#seasonality-years-slider .slider');
			const label = document.querySelector('#seasonality-years-slider .slider-hook-left .slider-hook-label');

			if (+val === 1) {
				slider.data('min', 9);
				label.textContent = '9 years';

				if (chartPage.form.get('seasonality_years') < 9) {
					chartPage.form.set('seasonality_years', 9);
				}
			} else {
				slider.data('min', 2);
				label.textContent = '2 years';
			}

			getCustomSeasonalityData();
		});

		chartPage.form.setCallback('seasonality_years', 'set', () => {
			getCustomSeasonalityData();
		});

		chartPage.form.setCallback('period_length', 'set', () => {
			if (section.find('.filters-advanced').data('toggled')) {
				getBestPeriod();
			}
		});

		chartPage.form.setCallback('seasonality_selection_start', 'set', () => {
			handleSeasonalitySelection();
		});

		chartPage.form.setCallback('seasonality_selection_end', 'set', () => {
			handleSeasonalitySelection();
		});
	}

	if (res.bestPeriod) {
		setBestPeriod(res.bestPeriod);
		chartPage.refreshData();
	}

	section.on('toggleAdvanced', function() {
		if ($(this).find('.filters-advanced').data('toggled')) {
			chartPage.form.set('future_timeline', 52);
			getBestPeriod();

			chartPage.section.find("[name='seasonality_selection_start']").trigger('change');
		} else {
			setBestPeriod(false);
			setSeasonalitySelection(defaultSeasonalityStart, defaultSeasonalityEnd);
		}
	});

	if (window.config.url.data[0] !== 'chart') {
		drawColumnChart(res);
		getNumYearsWithChange();
	} else {
		if (window.chartSettings && window.chartSettings.bestPeriod) {
			getBestPeriod(window.chartSettings.bestPeriod);
		}
	}
}
